import { Empty, Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useFeatureFlags } from "@/hooks/useUser"
import { DataReadinessPlaceholder } from "@/molecules/DataReadinessPlaceholder/DataReadinessPlaceholder"

import styles from "./HeaderDeploymentsTab.module.scss"

import type { EmptyStateWidgetProps } from "."

export const EmptyStateWidget = (props: EmptyStateWidgetProps) => {
  const { noUsageData, children } = props
  const kortexInstalled = useFeatureFlags("kortexInstalled")
  const setupRequired = kortexInstalled === false

  const showChildren = !setupRequired && !noUsageData
  const showPlaceHolder = !setupRequired && noUsageData

  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.widgets.empty"
  })

  return (
    <>
      {!showChildren && (
        <Flex flex={1} align="center" justify="center">
          {setupRequired && (
            <DataReadinessPlaceholder
              type="setup_required"
              title={t("noDeployedSensors")}
            />
          )}
          {showPlaceHolder && (
            <Flex
              vertical
              gap={2}
              align="center"
              className={styles.emptyStateWidget}
            >
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                className={styles.emptyStateWidgetIcon}
                description={false}
              />
              <Flex vertical align="center">
                <span className={styles.emptyStateWidgetTitle}>
                  {t("noData")}
                </span>
                <span>{t("notAvailable")}</span>
              </Flex>
            </Flex>
          )}
        </Flex>
      )}
      {showChildren && children}
    </>
  )
}
